import React from 'react'
import { makeStyles } from '@material-ui/core'
import Question from './Question'
import Group from './Group'
import Header from './Header'
import CategoryTitle from './CategoryTitle'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
    '@media (max-width: 960px)': {
      display: 'grid',
      gridColumnEnd: 'span 2',
    },
  },
}))

const title = 'توجه: هیچ سوالی بدون پاسخ نماند'

export default function Questions({ data = [], ...res }) {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      {data.map((question, index) => {
        const newCategory = question?.category
         && (question?.category?.id !== data?.[index - 1]?.category?.id)
        return (
          <React.Fragment key={question.id}>
            {newCategory && <CategoryTitle data={question.category} />}
            <Group
              key={question.id}
              newCategory={newCategory}
              groupNumber={+question?.exam?.id === 3 ? 15 : 20}
              index={index}
              header={<Header title={title} options={question.options} />}
            >
              <Question
                data={question}
                options={question.options}
                rowIndex={index + res?.after + 1}
                {...res}
              />
            </Group>
          </React.Fragment>
        )
      })}
    </div>
  )
}
